import React from 'react';
import './ProductHeader.css';

interface ProductHeaderProps {
  streakCount?: number;
}

const ProductHeader: React.FC<ProductHeaderProps> = ({ streakCount = 9 }) => {
  return (
    <div className="product-header">
      <div className="product-header-content">
        <img src="/images/logo-full.png" alt="aiCourses" className="product-header-logo" />
        <div className="streak-counter">
          <span className="streak-number">{streakCount}</span>
          <img src="/images/ui/flame.png" alt="Streak" className="streak-icon" />
        </div>
      </div>
    </div>
  );
};

export default ProductHeader; 